
import { FirearmAssignablePersonEntityDecoratorBase } from './firearm-assignable-person.decorator.base';


export class FirearmAssignablePersonEntityDecorator extends FirearmAssignablePersonEntityDecoratorBase {
  constructor() {
    super();
  }
}



